module.exports = __webpack_public_path__ + "img/snowboarding2.fb58685c.jpg";